import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LeftIndent01 = function LeftIndent01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21 9.25h-9M21 4H3m18 10.75h-9M21 20H3M4.28 8.56l3.8667 2.9c.2895.2171.4342.3257.486.4588a.5.5 0 0 1 0 .3624c-.0518.1331-.1965.2417-.486.4588L4.28 15.64c-.412.309-.618.4635-.7904.4599a.5.5 0 0 1-.3833-.1917C3 15.7725 3 15.515 3 15V9.2c0-.515 0-.7725.1063-.9082A.5.5 0 0 1 3.4896 8.1c.1724-.0036.3784.151.7904.4599"
    })
  }));
};
export default LeftIndent01;